import React, { useEffect, useState } from 'react'
import AddNewReleaseForm from './AddNewReleaseForm'
import ProcessNewRelease from './ProcessNewRelease';
import { NetworkManager } from '../../../Components/NetworkManager';
import { CommonUtil } from '../../../utils/CommonUtil';

const NewRelease = ({show, data, onClose, popupSize}: any) => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [step, setStep] = useState(2);
  const [step1, setStep1] = useState<any>(null);
  const [processes, setProcesses] = useState<any>([]);
  const [multiSeqId, setMultiSeqId] = useState<any>(data?.[0]?.multiSequence === null ? 0 : data?.[0]?.multiSequence);
  const docTypeId = data?.[0]?.isInterchnageEnabled ? data?.[0]?.docTypeId : null;

  let onLoginError = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
    if (step === 2) {
      popupSize(60);
    } else {
      popupSize(35);
    }
  }, [step]);

  useEffect(()=>{
    if(show || multiSeqId) getAllProcesses();
  },[show, multiSeqId])
  
  const getAllProcesses = () => {
    const orgUrl = `api/inspection/v2/document-inspection-process/all?orgId=${saasOrgId}&documentId=${data?.[0]?.documentId}&depenedentDocTypeId=${docTypeId}&multiSequence=${multiSeqId === null ? 0 : multiSeqId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData){
          setProcesses(restData?.result);
          }
      }
    }, onLoginError);
  };

  const handleStep1 = (item: any) => {
    if(item){
      setStep1(item);
      setStep(2)
    }
  }
  
  return (
    <div style={{ overflowX: "hidden", overflowY: "hidden", height: "100%" }}>
      {show && <>
        {step === 1 && <AddNewReleaseForm show={show} data={step1} onSubmit={handleStep1} />}
        {step === 2 && <ProcessNewRelease onClose={onClose} getAllProcesses={getAllProcesses} onPrev={((step: any)=>setStep(step))} 
          processes={processes} docTypeId={docTypeId} multiSeqId={(multiSeqId: any)=>setMultiSeqId(multiSeqId)} />}
      </>}
    </div>
  )
}

export default NewRelease
